import AnalyzePage from "./pages/AnalyzePage";

export default [
  { path: "/analyze", element: <AnalyzePage /> }
];
